import { defineMessages } from 'react-intl';

const messages: {
	emptyStateTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyStateSubtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	emptyStateTitle: {
		id: 'rovo-for-you.empty-state.title',
		defaultMessage: 'Nothing to see here...yet.',
		description:
			'Title text displayed in the empty state of the Rovo "For You" tab when no threads are available',
	},
	emptyStateSubtitle: {
		id: 'rovo-for-you.empty-state.subtitle',
		defaultMessage:
			"There's nothing for us to highlight here right now. Check back later as new work comes in.",
		description:
			'Subtitle text displayed in the empty state of the Rovo "For You" tab when no threads are available',
	},
});

export default messages;
